import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["firstName", "lastName", "yearLevel", "submit"]

  connect() {
    this.refreshSubmit()
  }

  refreshSubmit() {
    if (!this.hasSubmitTarget) return
    const filled = [this.firstNameTarget, this.lastNameTarget, this.yearLevelTarget]
      .every((el) => el && el.value && el.value.trim().length > 0)
    this.submitTarget.disabled = !filled
    this.submitTarget.setAttribute("aria-disabled", !filled)
  }
}
